import { OLAP_TOUR_TARGETS as T } from '@/components/olapV2/tour/olapTourTargets';
import i18n from '@/plugins/i18n';


// Shared guided-tour steps for every OLAP V2 page (WP-929). Every step is anchored to a
// shared OLAP element (olapTourTargets.js), so the same tour runs on any OLAP page — a page
// that lacks an element (no chart, no subrange, a readonly grid) simply drops that step,
// filtered out in OlapTour.vue. See docs/onboarding-unified-report-tour.md for the
// educational plan behind this order.
//
// title/description are pulled from the locale files (src/locales/{en,es,zh}.json) under
// `tour.olap.*`. They are exposed as getters so each read resolves against the active
// language — a plain `t('...')` value would freeze at import time and never follow a
// language switch. `en` is the source/fallback (fallbackLocale), so a partial es/zh still
// renders English rather than a raw key.
const t = (key) => i18n.global.t(key);

export const olapTourSteps = [
  {
    key: 'intro',
    target: null, // no anchor → el-tour centers this as a welcome card
    get title() { return t('tour.olap.intro.title'); },
    get description() { return t('tour.olap.intro.description'); },
  },
  {
    key: 'bp',
    target: T.bpSelect,
    placement: 'bottom-end',
    get title() { return t('tour.olap.bp.title'); },
    get description() { return t('tour.olap.bp.description'); },
  },
  {
    key: 'marketplace',
    target: T.marketplace,
    placement: 'bottom',
    get title() { return t('tour.olap.marketplace.title'); },
    get description() { return t('tour.olap.marketplace.description'); },
  },
  {
    key: 'date',
    target: T.datePicker,
    placement: 'bottom',
    get title() { return t('tour.olap.date.title'); },
    get description() { return t('tour.olap.date.description'); },
  },
  {
    key: 'configs',
    target: T.configs,
    placement: 'bottom',
    get title() { return t('tour.olap.configs.title'); },
    get description() { return t('tour.olap.configs.description'); },
  },
  {
    key: 'chart',
    target: T.chart,
    placement: 'top',
    get title() { return t('tour.olap.chart.title'); },
    get description() { return t('tour.olap.chart.description'); },
  },
  {
    key: 'subrange',
    target: T.subrange,
    placement: 'top',
    get title() { return t('tour.olap.subrange.title'); },
    get description() { return t('tour.olap.subrange.description'); },
  },
  {
    key: 'grid',
    // Dynamic anchor: on pages with a chart the grid sits in the lower part of the viewport, so
    // spotlight the whole table; on chart-less pages it fills the viewport top-to-bottom and the
    // popover would clip, so anchor to the header strip instead. Returns an element (el-tour and
    // resolveTarget both accept a function target that returns a node).
    target: () => (document.querySelector(T.chart)
      ? document.querySelector(T.grid)
      : document.querySelector(T.gridHeader)),
    placement: 'bottom',
    get title() { return t('tour.olap.grid.title'); },
    get description() { return t('tour.olap.grid.description'); },
  },
  {
    key: 'sidebar',
    target: T.sidebar,
    placement: 'left',
    get title() { return t('tour.olap.sidebar.title'); },
    get description() { return t('tour.olap.sidebar.description'); },
  },
];
